module.exports = __webpack_public_path__ + "media/notify.f3e7ac13.wav";